<template>
  <div class="secondpage">
    <div class="title_top">
      <el-row :gutter="24">
        <el-col :span="16" :xs="8" :sm="8" :md="8 " :lg="24" :offset="4" :class="!this.isMobile()? 'secondpage_con':'secondpage_conydd'">
          <div class="sx-iphone-button">
            <el-button :size="buttonSize" v-show="!isMobile()" @click="iphoneDown"
              ><i class="iconfont icon-shouji"></i>iPhone下载</el-button
            >
          </div>
          <div class="sx-android-button">
            <el-button :size="buttonSize" v-show="!isMobile()" @click="androidDown"
              ><i class="iconfont icon-anzhuo"></i>Android下载</el-button
            >
          </div>
          <!-- -------------------- -->
          <div v-show="isMobile()">
            <div class="ydd-iphone-button">
            <el-button :size="buttonSize" @click="iphoneDown"
              ><i class="iconfont icon-shouji"></i>iPhone下载</el-button
            >
          </div v-show="isMobile()">
          <div class="ydd-android-button">
            <el-button :size="buttonSize" @click="androidDown"
              ><i class="iconfont icon-anzhuo"></i>Android下载</el-button
            >
          </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 内容 -->
    <el-row class="content">
      <el-col :span="16" :offset="4">
        <el-row>
          <el-col :xs="24">
            <h1>给用户提供一揽子解决方案</h1>
            <p>
              涵盖了餐饮、外卖、超市便利、酒店、休闲娱乐等多个品类的线上服务
            </p>
          </el-col>
          <el-col
            class="hidden-xs-only"
            :xs="12"
            :sm="6"
            v-for="itemlist in content"
            :key="itemlist.id"
          >
            <div class="con_item">
              <img
                :src="'../../static/' + itemlist.imgsrc"
                alt=""
                width="50%"
              />
              <h3>{{ itemlist.title }}</h3>
              <p style="margin-top: -10px">{{ itemlist.content }}</p>
            </div>
          </el-col>
          <el-col
            class="hidden-sm-and-up"
            :xs="12"
            :sm="6"
            v-for="itemlist in content"
            :key="itemlist.title"
          >
            <div class="con_item">
              <img
                :src="'../../static/' + itemlist.imgsrc"
                alt=""
                width="50%"
              />
              <h5>{{ itemlist.title }}</h5>
              <p>{{ itemlist.content }}</p>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import "../assets/iconfont/iconfont.css";
import axios from "axios";
export default {
  data() {
    return {
      android:{
        platform:"aphone"
      },
      workTask: [],
      buttonSize: "medium",
      content: [
        {
          id: 1,
          title: "美食",
          content: "美食外送，轻松到家。品类全覆盖，应有尽有。",
          imgsrc: "meishi.png",
        },
        {
          id: 2,
          title: "超市便利",
          content: "满足便利性需求为第一宗旨，自选式购物方式的多元网上商店。",
          imgsrc: "lingshou.png",
        },
        {
          id: 3,
          title: "酒店住宿",
          content: "提供酒店实时价格查询及预订，和酒店图片与真实用户点评。",
          imgsrc: "zhusu.png",
        },
        {
          id: 4,
          title: "休闲娱乐",
          content: "提供包括密室、轰趴馆、桌游、手工坊等多种娱乐休闲的方式。",
          imgsrc: "yule.png",
        },
        {
          id: 5,
          title: "服务",
          content: "类目包含理发、美甲、家政、育儿、房地产、旅游等一站式服务。",
          imgsrc: "fuwu.png",
        },
        {
          id: 6,
          title: "衣帽品类",
          content: "敬请期待。。。",
          imgsrc: "chuanzhuo.png",
        },
        {
          id: 7,
          title: "出行",
          content: "敬请期待。。。",
          imgsrc: "chuxing.png",
        },
        {
          id: 8,
          title: "政务",
          content: "敬请期待。。。",
          imgsrc: "zhengwu.png",
        },
      ],
    };
  },
  created() {
    this.workTask = this.$route.query.id;
    // console.log(this.workTask)
  },
  methods: {
    isMobile() {
      let flag = window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|WebOS|Symbian|Windows Phone)/i
      );
      return flag ? true : false;
    },
    iphoneDown() {

      window.open('https://apps.apple.com/cn/app/%E4%B8%9C%E6%96%B9%E9%9B%86%E5%B8%82-%E6%9C%AC%E5%9C%B0%E7%94%9F%E6%B4%BB%E6%96%B0%E5%B9%B3%E5%8F%B0/id6446756097','_blank');

      // window.location.href =
      //   "https://apps.apple.com/cn/app/%E4%B8%9C%E6%96%B9%E9%9B%86%E5%B8%82-%E6%9C%AC%E5%9C%B0%E7%94%9F%E6%B4%BB%E6%96%B0%E5%B9%B3%E5%8F%B0/id6446756097";
   
   },
    androidDown() {
      // this.downloadRequest();
      // this.$axios.get("user/downloadFile").then((res) => {});
      axios.post('https://invinciblebackstage.df-js.cn/api/application/findLatestByRoleAndPlatform',this.android).then(resp=>{
        
        
        window.location.href = resp.data.data.url;
      })



      // window.location.href = "https://invinciblebackstage.df-js.cn/attachment/apk/5861/4935_4247.apk";
    },
    isMobile() {
      let flag = window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|WebOS|Symbian|Windows Phone)/i
      );
      return flag ? true : false;
    },
  },
  mounted() {
    
    if (this.isMobile()) {
      console.log("手机端");
      this.buttonSize = "mini";
    } else {
      console.log("pc端");
      this.buttonSize = "";
    }
  },
};
</script>

<style scoped>
.secondpage_con {
  margin: 280px auto;
}
.secondpage_conydd {
  margin: 150px auto;
}

.content h1,
.content h3,
.content h5,
.content p {
  color: #000000;
}

.ydd-iphone-button {
  position: absolute;
  left: 20%;
  width: 30%;
  top: 68%;
  height: 6%;
  cursor: pointer;
}

.ydd-android-button {
  position: absolute;
  left: 50%;
  width: 30%;
  top: 68%;
  height: 6%;
  cursor: pointer;
}

.sx-iphone-button {
  width: 13%;
  height: 200px;
  top: 68%;
  text-align: center;
  position: absolute;
  left: 34.5%;

  /* position: absolute;
  left: 35.6%;
  top: 68%;
  height: 6%;
  cursor: pointer; */
}
.sx-android-button {
  width: 13%;
 
  top: 68%;
  text-align: center;
  position: absolute;
  right: 34.5%;

  /* position: absolute;
  left: 54.3%;
  top: 68%;
  height: 6%;
  cursor: pointer; */
}

.title_top {
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #ffffff;
  background: url(../assets/2.jpg) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.content {
  margin: 80px auto;
}
.content .el-col {
  overflow: hidden;
  /* border: 1px solid #F0F2F5; */
}
.con_item {
  box-sizing: border-box;
  max-height: 15rem;
  max-width: 15rem;
  overflow: hidden;
  border: 0.0556rem solid #f0f2f5;
  margin: 1rem;
  padding: 0.1667rem;
}
.con_item p {
  font-size: 0.6667rem;
  color: #666666;
  display: inline-block;
  overflow: hidden;
  max-height: 2rem;
}
.con_item h3,
.con_item h5 {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue